var map = {
	"./1.png": 9184,
	"./2.png": 361,
	"./3.png": 987,
	"./4.png": 2181,
	"./5.png": 7949,
	"./6.png": 2277,
	"./7.png": 5672,
	"./ajlan.png": 4927,
	"./altukhi.png": 2592,
	"./ind1.png": 2476,
	"./ind2.png": 2841,
	"./ind3.png": 4763,
	"./leader.png": 124,
	"./leadership.png": 33,
	"./logo.png": 6061,
	"./marafiq.png": 2648,
	"./sabic.png": 4582,
	"./section1.png": 370,
	"./section2.png": 2084,
	"./section3.png": 9286,
	"./stars.png": 9120,
	"./zj.png": 7010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2110;